import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ViewAppUpdateInfo from './submodules/view';
import ListAppUpdateInfo from './submodules/list';

const AppUpdateDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getSuperAppUpdateLogs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListAppUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].viewSuperAppUpdateLogs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/view`}
				component={ViewAppUpdateInfo}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default AppUpdateDashboard;
